import CryptoJS from "crypto-js";

export  const encrypt = (word, keyStr)=>{
  keyStr = keyStr ? keyStr : "8KOASKg3c2B62G7nnR8R7lq7NQ89SN9l";
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
  // 加密

  // 解密
  // const decrypt = (word, keyStr) => {
  //   keyStr = keyStr ? keyStr : "默认密钥";
  //   var key = CryptoJS.enc.Utf8.parse(keyStr);
  //   var decrypt = CryptoJS.AES.decrypt(word, key, {
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7
  //   });
  //   return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  // }



// WEBPACK FOOTER //
// ./src/utils/encryption.js